import { render, staticRenderFns } from "./Sportlerfreigaben.vue?vue&type=template&id=275ea13f&scoped=true&"
import script from "./Sportlerfreigaben.vue?vue&type=script&lang=js&"
export * from "./Sportlerfreigaben.vue?vue&type=script&lang=js&"
import style0 from "./Sportlerfreigaben.vue?vue&type=style&index=0&id=275ea13f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275ea13f",
  null
  
)

export default component.exports